export enum InterventionTypeEnum {
  Assess = 1,
  Instruct = 2,
  Perform = 3
}

export const InterventionTypeOptions = [
{ id: 1, label: 'Assess' },
{ id: 2, label: 'Instruct' },
{ id: 3, label: 'Perform' }
];
